import { render, staticRenderFns } from "./SteamPersona.vue?vue&type=template&id=29b12040&"
import script from "./SteamPersona.vue?vue&type=script&lang=js&"
export * from "./SteamPersona.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports